var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSelectModeFaceBlack(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 51,
    height: 51,
    viewBox: "0 0 51 51",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\u30B0\\u30EB\\u30FC\\u30D7_17087",
    "data-name": "\\u30B0\\u30EB\\u30FC\\u30D7 17087",
    transform: "translate(3022 14780)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "\\u9577\\u65B9\\u5F62_15264",
    "data-name": "\\u9577\\u65B9\\u5F62 15264",
    width: 51,
    height: 51,
    transform: "translate(-3022 -14780)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Scan",
    transform: "translate(-3017.585 -14775.586)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_24869",
    "data-name": "\\u30D1\\u30B9 24869",
    d: "M3,12.65V6.217A3.217,3.217,0,0,1,6.217,3H12.65M3,35.166V41.6a3.217,3.217,0,0,0,3.217,3.217H12.65M44.816,12.65V6.217A3.217,3.217,0,0,0,41.6,3H35.166m9.65,32.166V41.6A3.217,3.217,0,0,1,41.6,44.816H35.166",
    transform: "translate(-3 -3)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("circle", {
    id: "\\u6955\\u5186\\u5F62_5082",
    "data-name": "\\u6955\\u5186\\u5F62 5082",
    cx: 12.622,
    cy: 12.622,
    r: 12.622,
    transform: "translate(8.415 7.797)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSelectModeFaceBlack);
export default __webpack_public_path__ + "static/media/selectModeFaceBlack.caa266711f9e6810a8ce1a224e30ac74.svg";
export { ForwardRef as ReactComponent };